import React, {useEffect, useState, useContext} from 'react'
import getCookie from '../../partials/cookie'
import { Errors } from '../../partials/Partials';
import {ContextProcessor, LoadingContext} from '../../partials/Context';

function AddLawyer() {
    const [show_lawyers, setShowLawyers] = useState(false);
    const [lawyers_list, setLawyersList] = useState([]);
    const [errors, setErrors] = useState({})
    const [found_lawyers, setFoundLawyers] = useState([]);
    const [success_info, setSuccessInfo] = useState('');
    const [display_instruction, setDisplayInstruction] = useState(false)
    const [cities, setCities] = useState([]);
    const csrftoken = getCookie('csrftoken');
    const {setLoading} = useContext(LoadingContext);
    const {lawyer_contact_phone} = useContext(ContextProcessor);
    const {city: city_errors, email: email_errors, first_name: first_name_errors, agreed_errors, consent_errors, id: errors_id} = errors || [];
    let cities_list = []

    useEffect(() => {
        fetch('/api/cities/').then(res => {
            res.json().then(
                data => {
                    setCities(data)
                }
            )
        })
    },[])

    useEffect(() => {
        if (found_lawyers.length <= 0) {
            return;
        }
        let temp_list = []
        setShowLawyers(true)

        found_lawyers.forEach(lawyer => {
            const {address_for_map, photo_url, person_name, id} = lawyer || ''
            temp_list.push(
                <div key={id}>
                    <div className="lawyer">
                        <div className="lawyer-info">
                            <img src={photo_url} alt="" />
                            <div className="lawyer-content">
                                <p id="name">{person_name}</p>
                                <p id="city">{address_for_map}</p>
                            </div>
                        </div>
                        <button type="button" onClick={(e)  =>regainAccount   (e, id)}>Tak to ja</  button>
                    </div>
                    {errors_id === id ?
                    <Errors small={true} errors={[...(agreed_errors ?   agreed_errors : ''), ...(consent_errors ?     consent_errors : '')]} />
                    : null }
                </div>
            )
        })
        setLawyersList(temp_list)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[found_lawyers, errors])


    const checkLawyers = (e) => {
        e.preventDefault();
        setLoading(true)
        setErrors([])
        let form = e.target.parentNode.parentNode
        const city = form.querySelector('#city').value
        const first_name = form.querySelector('#first_name').value
        const email = form.querySelector('#email').value
        const agreed = form.querySelector('#agreed').checked ? 'on' : 'off'
        const consent = form.querySelector('#consent').checked ? 'on' : 'off'

        let formData = new FormData()
        formData.append('city', city);
        formData.append('first_name', first_name);
        formData.append('email', email);
        formData.append('agreed', agreed);
        formData.append('consent', consent)

        
        fetch('/prawnik/znajdz/', {
                method: 'POST',
                headers: {
                        "X-CSRFToken": csrftoken
                    },
                body: formData
            }).then(res => {
                if (res.ok) {
                res.json().then(data => {
                    if (data.length > 0) {
                        setFoundLawyers(data)
                        setDisplayInstruction(true)
                    } else {
                        setDisplayInstruction(false)
                    }
                })
                } else {
                    setDisplayInstruction(false)
                }
                setLoading(false)
            })
    }

    
    const addNewLawyer = (e) => {
        e.preventDefault();
        const city = e.target.querySelector('#city').value
        const first_name = e.target.querySelector('#first_name').value
        const email = e.target.querySelector('#email').value
        const agreed = e.target.querySelector('#agreed').checked ? 'on' : 'off'
        const consent = e.target.querySelector('#consent').checked ? 'on' : 'off'

        setLoading(true)
        let formData = new FormData()
        formData.append('city', city);
        formData.append('first_name', first_name);
        formData.append('email', email);
        formData.append('agreed', agreed);
        formData.append('consent', consent)

        fetch('/dodaj-prawnika/sprawdz/', {
            method: 'POST',
            headers: {
                    "X-CSRFToken": csrftoken
                },
            body: formData
            }).then(res => {
                if (res.ok) {
                    res.json().then(data => {
                        setSuccessInfo(data.message)
                    })
                    setLoading(false)
                } else {
                    res.json().then(data => {
                        setErrors(data)
                    })
                    setLoading(false)
                }
            })
    }


    const regainAccount = (e, id) => {
        let formData = new FormData()
        formData.append('profile_id', id);
        const agreed = e.target.parentNode.parentNode.parentNode.parentNode.querySelector('#agreed').checked
        const consent = e.target.parentNode.parentNode.parentNode.parentNode.querySelector('#consent').checked
        setLoading(true)
        if (agreed && consent) {
        fetch('/prawnik/przejmij-konto/', {
            method: 'POST',
            headers: {
                    "X-CSRFToken": csrftoken
            },
            body: formData
            }).then(res => {
                if (res.ok) {
                    res.json().then(
                        data => {
                            setSuccessInfo(data.warning)
                        }
                    )
                    setErrors([])
                }
            })
        } else {
            if (!consent && !agreed) {
                setErrors({
                    id: id,
                    consent_errors: ['Jeszcze tylko wyraź zgodę na przetwarzanie danych osobowych'],
                    agreed_errors: ['Jeszcze tylko zaakceptuj regulamin']
                })
            } else if (!consent && agreed) {
                setErrors({id: id, consent_errors: ['Jeszcze tylko wyraź zgodę na przetwarzanie danych osobowych']})
            } else if (!agreed && consent) {
                setErrors({id: id, agreed_errors: ['Jeszcze tylko zaakceptuj regulamin']})
            } else {
                setErrors({...errors})
            }
        }
        setLoading(false)
    }

    if (cities) {
        cities.forEach(city => {
            const {name, id} = city || ''
            cities_list.push(
                <option
                    key={id} value={name}>{name}
                </option>
            )
        })
        cities_list.unshift(
            <option key="0"></option>
        )
    }

    const convertPhone = (text) => {
        if (text && text.length > 0) {
            let plain_number = text.slice(3);
            return `${plain_number.slice(0,3)} ${plain_number.slice(3,6)}  ${plain_number.slice(6,9)}`
        }
    }

    
  return (
    <div id="add-lawyer">
        <div id="add-form">
            {success_info ?
                <div className="alert alert-warning">
                    <div dangerouslySetInnerHTML={{__html: success_info}}></div>
                </div> : null
            }
        <h1>Zacznij od utworzenia profilu prawnika w serwisie (tylko dla prawników)</h1>
        <form onSubmit={(e)=>addNewLawyer(e)}>
            <input type="hidden" name="csrfmiddlewaretoken" value={csrftoken} autoComplete="off"></input>
            <div className="form-group">
                <label htmlFor="city">Miasto</label>
                <input type="text" list="city-list" id="city"/>
                <datalist id="city-list" >
                    {cities_list}
                </datalist>
                <Errors small={true} errors={city_errors ? city_errors : []} />
                
            </div>
            <div className="form-group">
                <label htmlFor="first_name">Imię i nazwisko</label>
                <input type="text" id="first_name" onChange={(e)=> checkLawyers(e)}/>
                <Errors small={true} errors={first_name_errors ? first_name_errors : []} />
            </div>
            <div className="form-group">
                <label htmlFor="email">Email</label>
                <input type="email" id="email" onChange={(e)=> checkLawyers(e)}/>
                <Errors small={true} errors={email_errors ? email_errors : []} />
            </div>
            <div className="agree">
            <label>
                <input type="checkbox" name="agreed" required id="agreed"/>
                Potwierdzam, że zapoznałem się i akceptuję&nbsp;  
                <a href="/regulamin-dla-prawnikow/">Regulamin dla prawnika</a>
            </label>
        </div>
        <div className="agree">
            <label>
                <input type="checkbox" name="consent" required id="consent"/>
                Oświadczam, że wyrażam zgodę na przetwarzanie przekazywanych moich danych osobowych.&nbsp; 
                <a href="/dane-osobowe/">Jak przetwarzamy Twoje dane osobowe</a>
            </label>
        </div>
            <p className="phone-block">Masz pytanie? Zadzwoń: 
                <a href={`tel:${lawyer_contact_phone}`}>&nbsp;{convertPhone(lawyer_contact_phone)}</a>
            </p>
            <button type="submit" className="btn btn-primary">Załóż konto prawnika</button>
            {display_instruction ? 
                <span className="instruction">&nbsp;* Jeśli nie figurujesz po prawej stronie</span>
            : null
            }
            </form>
            </div>
            {show_lawyers  ?
            <div id="existing-lawyers">
                <h1 className="title-blue">Może u nas figurujesz?</h1>
                {lawyers_list}
            </div>
            : null }

    </div>
  )
}

export default AddLawyer